import * as React from 'react';

import TransactionForm from 'components/forms/TransactionForm';
import ContentWrapper from 'components/ContentWrapper';

const TransactionCreateScreen = () => (
  <ContentWrapper>
    <TransactionForm />
  </ContentWrapper>
);

export default TransactionCreateScreen;
